import React, { useState } from "react";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Box,
  Typography,
  Container,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";
import PublicLayout from "layouts/publicLayout";
import Copyright from "components/copyright";
import { toast } from "react-toastify";
import axios from "axios";
import { useApiClient } from "context/ApiClientContext";


export default function ActivationUser() {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const apiClient = useApiClient();
  
  const handleAccount = (property, event) => {
    const dataCopy = { ...data };
    dataCopy[property] = event.target.value;
    setData(dataCopy);
  };

  const handleSubmit = async () => {
    try {

      await axios.get(
        `${apiClient}/company`,
        data,
        {
          headers: {
            Authorization:`Bearer ${localStorage.getItem('token')}`,
            Accept: "application/json",
          },
        }
      );


      toast.success("Your account has been activated.", {
        position: "top-right",
      });

      navigate("/signin");
      //   return result;
    } catch (error) {
      // Handle the error if needed
      toast.error("The code is expired. Please contact your admin.", {
        position: "top-right",
      });
      // console.error("Authentication failed!", error);
    }
  };

  return (
    <PublicLayout>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography>
            Please enter your email address and activation code to activate your
            account.
          </Typography>

          {/* <Box sx={{ mt: 1 }}> */}
          <TextField
            onChange={(event) => handleAccount("email", event)}
            margin="normal"
            required
            fullWidth
            variant="standard"
            id="email"
            label="Email"
            name="email"
            autoFocus
          />

          <TextField
            onChange={(event) => handleAccount("code", event)}
            margin="normal"
            required
            fullWidth
            variant="standard"
            id="code"
            label="Code"
            name="code"
            autoFocus
          />
          <Box display="flex" justifyContent="start" fullWidth>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ mt: 3, mb: 2 }}
              onClick={handleSubmit}
            >
              Activate my account
            </Button>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </PublicLayout>
  );
}
